import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import home from "../views/Home.vue";
import login from "../views/LoginView.vue";
import cerrarApp from "../components/Login/cerrarApp.vue";
import cambiarPassword from "../views/cambiarPasswordView.vue";
import descargarBoletaPago from "../views/descargarBoletaPagoView.vue";
import verificaqr from "../views/verificaqrView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: home,
    meta: {
      Logueado: true,
    },
  },
  {
    path: "/exitApp",
    name: "exitApp",
    component: cerrarApp,
    meta: {
      Libre: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: login,
    meta: {
      Libre: true,
    },
  },
  {
    path: "/cambiarPassword",
    name: "cambiarPassword",
    component: cambiarPassword,
    meta: {
      Logueado: true,
    },
  },
  {
    path: "/descargarBoletaPago",
    name: "descargarBoletaPago",
    component: descargarBoletaPago,
    meta: {
      Logueado: true,
    },
  },
  {
    path: "/verificaqr/:qr",
    name: "verificaqr",
    component: verificaqr,
    meta: {
      Libre: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.Libre)) {
    next();
  } else if (store.state.usuario && store.state.usuario.estado == "Logueado") {
    if (to.matched.some((record) => record.meta.Logueado)) {
      next();
    }
  } else {
    next({ name: "Login" });
  }
});

export default router;
